import {Button} from "antd";
import styles from "./SearchComponent.module.css";

export const SearchComponent = ({sendRequest, searchInProgress, query, onQueryChange}) => {
	return (
		<div className={styles.searchRow} data-testid="app-search-row">
			<form onSubmit={sendRequest} className={styles.searchForm} autoComplete="off" data-testid="app-search-form">
				<input
					className={styles.searchInput}
					name="search"
					autoComplete="off"
					value={query || ""}
					placeholder="To submit query press Enter or Search button..."
					onChange={event => onQueryChange(event.target.value)}
					disabled={searchInProgress}
					data-testid="app-search-input"
				/>
				<Button
					id="search-button"
					className={styles.searchButton}
					data-testid="app-search-button"
					loading={searchInProgress}
					onClick={sendRequest}>
					Search
				</Button>
			</form>
		</div>
	);
};
